// extracted by mini-css-extract-plugin
export default {"productGrid":"v--z","centerLink":"w--z","productSection":"x--z","item":"y--z","ctaButton":"z--z"};